// Auto-loads every per-object sky-map file generated by
// scripts/generate-sky-data.js. New objects appear here automatically on the
// next build with no manual edit.
const context = require.context('./', false, /\.json$/);

const skyMaps = context.keys().reduce((maps, file) => {
    const key = file.replace(/^\.\//, '').replace(/\.json$/, '');
    maps[key] = context(file);
    return maps;
}, {});

export default skyMaps;
